import React, { useState, useEffect } from 'react';

function AddClientDialog({ onClose, onSave, initialData }) {
    const [clientData, setClientData] = useState(initialData || {
        billingName: '',
        mobile: '',
        email: '',
        billingAddress: '',
        contact: '',
        phone: '',
        website: '',
        taxNumber: ''
    });

    useEffect(() => {
        if (initialData) setClientData(initialData);
    }, [initialData]);

    const handleSave = () => {
        if (clientData.billingName) {
            onSave(clientData);
        }
    };

    useEffect(() => {
        return () => onClose();
    }, [onClose]);

    return (
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog-content wide-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="dialog-header">
                    <h3>Add Client</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="dialog-body">
                    <div className="form-row">
                        <div className="form-group">
                            <label>Billing name</label>
                            <input
                                type="text"
                                placeholder="Jane Industries"
                                value={clientData.billingName}
                                onChange={(e) => setClientData({...clientData, billingName: e.target.value})}
                                autoFocus
                            />
                        </div>
                        <div className="form-group">
                            <label>Mobile</label>
                            <input
                                type="tel"
                                placeholder="06 12345678"
                                value={clientData.mobile}
                                onChange={(e) => setClientData({...clientData, mobile: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder="jane@smith.com"
                                value={clientData.email}
                                onChange={(e) => setClientData({...clientData, email: e.target.value})}
                            />
                        </div>
                        <div className="form-group">
                            <label>Billing address</label>
                            <input
                                type="text"
                                placeholder="4969 Clousson Road..."
                                value={clientData.billingAddress}
                                onChange={(e) => setClientData({...clientData, billingAddress: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Contact</label>
                            <input
                                type="text"
                                placeholder="Jane Smith"
                                value={clientData.contact}
                                onChange={(e) => setClientData({...clientData, contact: e.target.value})}
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone</label>
                            <input
                                type="tel"
                                placeholder="Number"
                                value={clientData.phone}
                                onChange={(e) => setClientData({...clientData, phone: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Website</label>
                            <input
                                type="url"
                                placeholder="www.smith.com"
                                value={clientData.website}
                                onChange={(e) => setClientData({...clientData, website: e.target.value})}
                            />
                        </div>
                        <div className="form-group">
                            <label>Tax number</label>
                            <input
                                type="text"
                                placeholder="TX12345678"
                                value={clientData.taxNumber}
                                onChange={(e) => setClientData({...clientData, taxNumber: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
                <div className="dialog-footer">
                    <button className="btn-cancel" onClick={onClose}>Cancel</button>
                    <button className="btn-save" onClick={handleSave}>Save Client</button>
                </div>
            </div>
        </div>
    );
}

export default AddClientDialog;
